import request from '@/utils/request'

/**
 * 查询金币设置列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function querySystemGoldSetting(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/systemGoldSetting/querySystemGoldSetting',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新金币设置
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function updateSystemGoldSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/systemGoldSetting/updateSystemGoldSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加金币设置
 * @param {Object} data 添加数据
 * @returns {Promise} Promise对象
 */
export function addSystemGoldSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/systemGoldSetting/addSystemGoldSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除金币设置
 * @param {String} settingId 设置ID
 * @returns {Promise} Promise对象
 */
export function deleteSystemGoldSetting(settingId) {
  return new Promise((resolve, reject) => {
    request({
      url: `/systemGoldSetting/deleteSystemGoldSetting/${settingId}`,
      method: 'delete'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}